import { IPaging, IPagingFromTo } from 'core-components/types'

const getPagingFromTo = (paging: IPaging) => {
  const startPage = paging.page - (paging.startPage || 0)
  return {
    from: startPage * paging.pageSize,
    to: (startPage + 1) * paging.pageSize,
  }
}

export const splitPagingData = <T>(currentData: T[], paging: IPaging | IPagingFromTo) => {
  // When paging.to equals paging.from and items exist we return first item in query
  if ('from' in paging && paging.to - paging.from <= 1 && currentData.length) {
    return [currentData[0]]
  }
  const pagingFromTo = 'page' in paging ? getPagingFromTo(paging) : paging
  const length = pagingFromTo.to - pagingFromTo.from
  return currentData.slice(0, length)
}
